import React from 'react'
import classNames from 'classnames'
import Popover from 'antd/lib/popover'
import styles from './index.module.less'
if (__isBrowser__) {
  require('antd/lib/popover/style/css.js')
}

const recordContent = (links) => {
  return (
    <div className={styles.nav_more}>
      {
        links.map((link) => (
          link.index > 16 && (<span key={link.itemId} index={link.index} className={(link.index >= 22 && link.index < 33) ? 'm-nav-hide' : link.index > 16 && link.index <= 22 ? 's-nav-hide' : ''}>
            <a
              title={link.index}
              target={link.blankTarget ? '_blank' : '_self'}
              href={link.url}>
              {link.title}
            </a>
          </span>)
        ))}
    </div>
  )
}

const NavChanel = ({ className, data }) => {
  const clsString = classNames(styles.nav_chanel, className)
  const links = data.textNavList
  const trackInfo = data.trackInfo
  return (
    <div className={clsString}
      data-spm={data.spm}
      data-name='c_pos'
      data-mname={trackInfo.drawer}
      data-cname={trackInfo.component_title}
      data-cid={trackInfo.component_id}
      data-mid={trackInfo.drawerid}
      data-trackinfo={JSON.stringify(trackInfo)}>
      {links && (
        <ul className={styles.links}>
          {links.map((link, index) => (
            link.index < 33 && (<li key={link.itemId} className={(link.index >= 22 && link.index < 33) ? 'm-hide' : link.index > 16 && link.index < 22 ? 's-hide' : ''}>
              <a
                title={link.index}
                target={link.blankTarget ? '_blank' : '_self'}
                href={link.url}
                data-spm={link.spm}
                data-mname={trackInfo.drawer}
                data-cname={trackInfo.component_title}
                data-cid={trackInfo.component_id}
                data-mid={trackInfo.drawerid}
                data-trackinfo={JSON.stringify(link.trackInfo)}>
                {link.title}
              </a>
            </li>)
          ))}
          <li >
            <Popover placement='bottomRight' content={recordContent(links)}>
                    更多
            </Popover>
          </li>
        </ul>
      )}
    </div>
  )
}

export default NavChanel
